<template>
  <Dialog
    custom-class="pg-dialog-result pg-dialog"
    :title="title"
    :visible="props.visible"
    :modal="props.modal"
    :before-close="props.onCancel"
    :append-to-body="props.appendToBody"
    :close-on-click-modal="!showProgress"
    :close-on-press-escape="!showProgress"
    :show-close="!showProgress"
    :width="props.width"
    @close="close"
    @closed="onClosed"
  >
    <div class="pg-dialog-result__progress" v-if="showProgress">
      <span class="pg-dialog-result__progress-title">正在处理...</span>
      <Progress
        class="pg-dialog-result__progress-pro"
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
      ></Progress>
    </div>
    <div class="pg-dialog-result__content flex flex-pack-center flex-align-center" v-else>
      <i class="ivu-icon ivu-icon-icon-pg-dagou"></i>
      <!-- 新版显示文本 -->
      <div>
        <span v-if="props.textTemplate" v-html="_textTemplate"></span>
        <a
          :href="props.downLoadFailUrl"
          v-if="props.downLoadFailUrl && props.resultData?.faild > 0"
          class="download-text"
          >点击下载失败条目信息</a
        >
      </div>
    </div>
    <!-- footer -->
    <template #footer v-if="!showProgress">
      <slot name="footer" class="pg-dialog-result__content-footer">
        <Button v-if="props.leftBtnText" type="primary" round @click="leftClick"
          >{{ props.leftBtnText }}
        </Button>
        <Button round type="primary" style="width: 160px" @click="close">确认</Button>
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
import { computed, shallowReactive, getCurrentInstance } from 'vue'
import { Dialog, Progress, Button } from 'element-ui'

const props = shallowReactive({
  appendToBody: true,
  visible: true,
  modal: true,
  title: '更新',
  width: '494px',
  // 提示语 模板字符串
  textTemplate: '$title$完毕！本次$title$成功$success$条, 失败$faild$',
  // {success: Number, faild: Number} 配置
  resultData: null,
  // 下载错误信息的url
  downLoadFailUrl: '',
  leftBtnText: null,
  close: null, //该属性不允许配置
  closed: null,
})

const showProgress = computed(
  () => props.resultData?.total > 0 && props.resultData?.status?.code === 'DOING'
)
const title = computed(() => (showProgress.value ? `${props.title}中` : `${props.title}结果`))
const percentage = computed(() =>
  showProgress.value
    ? Math.floor(
        ((props.resultData?.success + props.resultData?.faild) / props.resultData?.total) * 100
      )
    : 0
)

const { proxy } = getCurrentInstance()
const emit = defineEmits(['left-sure'])
const _textTemplate = computed(() => {
  let str = props.textTemplate
  // 找到成功模版字符串
  if (props.textTemplate.indexOf('$title$') !== -1) {
    let reg = /\$title\$/g
    str = str.replace(reg, props.title)
  }
  if (props.textTemplate.indexOf('$success$') > 0) {
    let reg = /\$success\$/
    str = str.replace(reg, props.resultData?.success)
  }
  // 找到失败模板字符串
  if (props.textTemplate.indexOf('$faild$') > 0) {
    let reg = /\$faild\$/
    str = str.replace(reg, props.resultData?.faild)
  }
  return str
})

const leftClick = async () => {
  emit('left-sure')
}

const updateProps = (options) => {
  Object.keys(options).forEach((option) => (props[option] = options[option]))
}

const show = (options) => {
  updateProps(options)
  props.visible = true
}

const close = () => {
  //清楚数组中的引用
  props.close?.()
  props.visible = false
}

const onClosed = () => {
  //执行动画完成后的回调
  props?.closed?.()
  proxy.$destroy(true)
  proxy.$el.parentNode?.removeChild(proxy.$el)
}

//暴漏的方法
defineExpose({
  show,
  updateProps,
})
</script>
<style lang="scss">
@import '../style/dialog-update-result.scss';
</style>
